import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

const typeClasses = {
  error: 'bg-danger text-white',
  info: 'bg-primary-blue text-white',
  success: 'bg-success text-white',
  warning: 'bg-warning text-white',
  custom1: 'bg-danger text-white',
}

const Notice = ({ children, type }) => (
  <div className={classNames(
    'rounded-lg font-semibold mb-4 py-2 px-8 text-center last:mb-0 animate-[shakeHorizontal_0.5s_ease-in-out]',
    typeClasses[type]
  )}>
    {children}
  </div>
)

Notice.propTypes = {
  children: PropTypes.node.isRequired,
  type: PropTypes.oneOf(['error', 'info', 'success', 'warning', 'custom1'])
    .isRequired,
}

export default Notice
